import PropTypes from 'prop-types';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import NavItem from './NavItem';
import { useGetMenuMaster } from 'api/menu';
import { useAuth } from 'sections/authentication/context/UseAuth';

export default function NavGroup({ item }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const { hasRole } = useAuth();

  const children = Array.isArray(item.children) ? item.children : [];
  const filtered = children.filter((m) => !m.allowedRoles || hasRole(m.allowedRoles));

  return (
    <Box sx={{ mb: drawerOpen ? 2 : 0 }}>
      {drawerOpen && item.title ? (
        <Typography
          variant="caption"
          sx={{ 
            px: 2, 
            py: 1.5, 
            color: '#6b7280', 
            textTransform: 'uppercase', 
            letterSpacing: '0.1em',
            fontSize: '0.7rem',
            fontWeight: 700
          }}
        >
          {item.title}
        </Typography>
      ) : null}

      <List sx={{ py: 0.5 }}>
        {filtered.map((menuItem) => (menuItem.type === 'item' ? <NavItem key={menuItem.id} item={menuItem} level={1} /> : null))}
      </List>
    </Box>
  );
}

NavGroup.propTypes = { item: PropTypes.object };
